import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { App } from "@/App"
import "src/polyfills/form-request-submit-polyfill" // for Safari, all versions 🙁

const container = document.getElementById("root")

if (container) {
  const root = createRoot(container)
  root.render(
    <StrictMode>
      <App />
    </StrictMode>
  )
}
